import React, { useState, Fragment, useRef } from "react";
import Geosuggest, { Suggest } from "@ubilabs/react-geosuggest";
import _isEmpty from "lodash/isEmpty";
import { ShopLocation } from "../../../../../../models/state";
import TEXT from "../../../text-consts";
import "./Search.less";

interface SearchProps {
    setSelectedSearchLocation: (location?: ShopLocation | null) => void;
}

const Search: React.FC<SearchProps> = ({ setSelectedSearchLocation }) => {
    const [suggestNoResults, setSuggestNoResults] = useState(false);
    const refGeosuggest = useRef<Geosuggest>(null);

    const onChange = () => {
        // The search has changed so any previously selected location is invalid
        setSelectedSearchLocation(null);
    };

    const onSuggestSelect = (suggestion?: Suggest) => {
        // Only trigger selection select if label (ie search string) is set
        const label = suggestion?.label;
        if (!label) {
            return;
        }

        setSelectedSearchLocation(suggestion.location);
    };

    const getSuggestLabel = ({ description }: { description: string }) => {
        setSuggestNoResults(false);
        // We don't need to show the country, we only search in Norway :-)
        return description.replace(/, (Norway|Norge|Noreg)/, "");
    };

    const onSuggestNoResults = (userInput: string) => {
        if (!_isEmpty(userInput)) {
            setSuggestNoResults(true);
        }
    };

    return (
        <Fragment>
            <div className="textbox-with-label__input-icon-wrapper">
                <Geosuggest
                    id="shop-picker-geosuggest"
                    label={TEXT.SEARCH_LABEL}
                    minLength={2}
                    ref={refGeosuggest}
                    inputClassName="textbox-with-label__input search-field"
                    placeholder={TEXT.SEARCH_LABEL_PLACEHOLDER}
                    country="no"
                    getSuggestLabel={getSuggestLabel}
                    onChange={onChange}
                    onSuggestSelect={onSuggestSelect}
                    types={["(regions)"]}
                    onSuggestNoResults={onSuggestNoResults}
                />
            </div>
            {suggestNoResults && <p>{TEXT.NO_SUGGESTIONS}</p>}
        </Fragment>
    );
};

export default Search;
